"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _react = _interopRequireWildcard(require("react"));

var _reactRedux = require("react-redux");

var _UpdateSiteSettings = _interopRequireDefault(require("../stagedObjects/UpdateSiteSettings"));

var _PagesSettingsContainer = _interopRequireDefault(require("../containers/PagesSettingsContainer"));

var _updateSiteSettingsSelectors = require("../selectors/staging/updateSiteSettingsSelectors");

var _pageTemplateSettingsSelectors = require("../selectors/pageTemplateSettingsSelectors");

var PageSettingsWrapper =
/*#__PURE__*/
function (_PureComponent) {
  (0, _inherits2.default)(PageSettingsWrapper, _PureComponent);

  function PageSettingsWrapper() {
    (0, _classCallCheck2.default)(this, PageSettingsWrapper);
    return (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(PageSettingsWrapper).apply(this, arguments));
  }

  (0, _createClass2.default)(PageSettingsWrapper, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          children = _this$props.children,
          numberOfStagedChanges = _this$props.numberOfStagedChanges,
          siteSettingsForSaving = _this$props.siteSettingsForSaving;
      return _react.default.createElement(_PagesSettingsContainer.default, {
        stageForEdit: this.props.stageForEdit,
        resetChanges: this.props.resetChanges,
        numberOfStagedChanges: numberOfStagedChanges,
        siteSettingsForSaving: siteSettingsForSaving
      }, _react.default.createElement("div", {
        className: "p-bottom-10"
      }, children));
    }
  }]);
  return PageSettingsWrapper;
}(_react.PureComponent);

PageSettingsWrapper.propTypes = {
  children: _react.PropTypes.node.isRequired,
  stageForEdit: _react.PropTypes.func.isRequired,
  numberOfStagedChanges: _react.PropTypes.number.isRequired,
  siteSettingsForSaving: _react.PropTypes.object.isRequired,
  resetChanges: _react.PropTypes.func.isRequired
};

var mapStateToProps = function mapStateToProps(state) {
  return {
    numberOfStagedChanges: (0, _pageTemplateSettingsSelectors.getNumberOfStagedChanges)(state),
    siteSettingsForSaving: (0, _updateSiteSettingsSelectors.getSiteSettingsForSaving)(state)
  };
};

var mapDispatchToProps = {
  resetChanges: _UpdateSiteSettings.default.resetChangesToStagedObject,
  stageForEdit: _UpdateSiteSettings.default.stageForEdit
};

var _default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(PageSettingsWrapper);

exports.default = _default;
module.exports = exports.default;